import extendedPropertyUri from 'owa-service/lib/factory/extendedPropertyUri';
import folderId from 'owa-service/lib/factory/folderId';
import folderResponseShape from 'owa-service/lib/factory/folderResponseShape';
import getFolderRequest from 'owa-service/lib/factory/getFolderRequest';
import propertyUri from 'owa-service/lib/factory/propertyUri';
import getFolderOperation from 'owa-service/lib/operation/getFolderOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
export var PERSONA_NODE_ID_PROPERTY = 'PersonaId';
// This property is created as described at https://msdn.microsoft.com/en-us/library/office/dd633654(v=exchg.80).aspx
// The guid is generted randomly. The value contains a string representation of the query used for the search folder
export var EXTENDED_PROPERTY_QUERY = {
    PropertySetId: '{544b025e-cb61-4562-b021-16f4dcb2a7ac}',
    PropertyName: 'Query',
    PropertyType: 'String',
};
export var EXTENDED_PROPERTY_PERSONA_NODE_ID = {
    PropertySetId: '{1ffa50b8-9483-48df-ab40-de558669a5dc}',
    PropertyName: PERSONA_NODE_ID_PROPERTY,
    PropertyType: 'String',
};
export function searchFolderShape() {
    return folderResponseShape({
        BaseShape: 'IdOnly',
        AdditionalProperties: [
            propertyUri({ FieldURI: 'UnreadCount' }),
            propertyUri({ FieldURI: 'TotalCount' }),
            propertyUri({ FieldURI: 'FolderDisplayName' }),
            extendedPropertyUri(EXTENDED_PROPERTY_QUERY),
            extendedPropertyUri(EXTENDED_PROPERTY_PERSONA_NODE_ID),
        ],
    });
}
export default function fetchFavoritePersonaSearchFolder(targetFolderId) {
    return getFolderOperation({
        Header: getJsonRequestHeader(),
        Body: getFolderRequest({
            FolderShape: searchFolderShape(),
            FolderIds: [folderId({ Id: targetFolderId })],
        }),
    }).then(function (response) {
        return response.Body.ResponseMessages.Items[0]
            .Folders[0];
    });
}
export function fetchMultipleFavoritePersonaSearchFolders(targetFolderIds) {
    return getFolderOperation({
        Header: getJsonRequestHeader(),
        Body: getFolderRequest({
            FolderShape: searchFolderShape(),
            FolderIds: targetFolderIds.map(function (targetFolderId) { return folderId({ Id: targetFolderId }); }),
        }),
    }).then(function (response) {
        var responseItems = response.Body.ResponseMessages.Items;
        var successfulResponses = responseItems.filter(function (item) { return item.ResponseClass === 'Success'; });
        return successfulResponses.map(function (response) { return response.Folders[0]; });
    });
}
//# sourceMappingURL=fetchFavoritePersonaSearchFolder.js.map